import { useState, useRef, useEffect } from "react";
import { categories } from "@/mocks/categories";

export default function CategoryDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState<string | null>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (cat: typeof categories[0]) => {
    setSelected(cat.nameDe);
    setIsOpen(false);
    window.open(cat.url, "_blank", "noopener,nofollow");
  };

  return (
    <section className="max-w-3xl mx-auto px-4 md:px-6 -mt-8 relative z-20">
      <div className="bg-background-50 rounded-2xl p-6 md:p-8" ref={dropdownRef}>
        <p className="text-foreground-600 text-sm mb-3">Wähle eine Produktkategorie:</p>
        <div className="relative">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="w-full flex items-center justify-between bg-background-100 hover:bg-background-200 border border-background-200/70 rounded-xl px-5 py-3.5 text-foreground-900 text-sm font-medium transition-colors cursor-pointer"
          >
            <span>{selected || "Kategorie auswählen..."}</span>
            <div className="w-5 h-5 flex items-center justify-center">
              {isOpen ? (
                <i className="ri-arrow-up-s-line text-foreground-500"></i>
              ) : (
                <i className="ri-arrow-down-s-line text-foreground-500"></i>
              )}
            </div>
          </button>

          {isOpen && (
            <div className="absolute top-full left-0 right-0 mt-2 bg-background-50 border border-background-200/70 rounded-xl shadow-lg overflow-hidden z-50 max-h-64 overflow-y-auto">
              {categories.map((cat) => (
                <button
                  key={cat.name}
                  onClick={() => handleSelect(cat)}
                  className="w-full flex items-center gap-3 px-5 py-3 text-left text-foreground-700 hover:bg-background-100 text-sm transition-colors cursor-pointer whitespace-nowrap"
                >
                  <div className="w-7 h-7 flex items-center justify-center">
                    <i className={`${cat.icon} text-foreground-500`}></i>
                  </div>
                  <span>{cat.nameDe}</span>
                  <span className="text-foreground-400 text-xs ml-auto">{cat.name}</span>
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}